import { useEffect, forwardRef } from "react";
import L from "leaflet";
import PropTypes from "prop-types";
import "leaflet-control-geocoder";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";

L.Marker.prototype.options.icon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
});

const RoutingMachine = forwardRef(({ from, to }, ref) => {
  const map = ref?.current?.leafletElement;

  useEffect(() => {
    if (!map) return;

    const routingControl = L.Routing.control({
      waypoints: [L.latLng(from?.[0], from?.[1]), L.latLng(to?.[0], to?.[1])],
      routeWhileDragging: true,
      geocoder: L.Control.Geocoder.nominatim(),
      language: "id",
    }).addTo(map);

    return () => map.removeControl(routingControl);
  }, [map]);

  return null;
});

export default RoutingMachine;

RoutingMachine.propTypes = {
  from: PropTypes.array,
  to: PropTypes.array,
};
